import { render, staticRenderFns } from "./product-inventory-list.vue?vue&type=template&id=14c31bb2&scoped=true&"
import script from "./product-inventory-list.vue?vue&type=script&lang=ts&"
export * from "./product-inventory-list.vue?vue&type=script&lang=ts&"
import style0 from "./product-inventory-list.vue?vue&type=style&index=0&id=14c31bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c31bb2",
  null
  
)

export default component.exports